// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-3GaKU","icons":"icons-sZGsb","icon":"icon-Shzxy","popularBadge":"popularBadge-2UCCR","badge":"badge-2lpWJ"};